const createProductSlugFilter = (products) => {
  // initial copying of old CMS product data had instances of empty product objects
  // filter out null slug values
  const filteredProducts = products.filter((prod) => prod.product_slug);

  // create a filter out of the product object's product_slug values
  const filter = filteredProducts?.reduce((acc, curr, index) => {
    const { product_slug } = curr;
    let filterValue = acc;
    if (index === 0) filterValue += `slug:"${product_slug}"`;
    else filterValue += ` OR slug:"${product_slug}"`;
    return filterValue;
  }, '');

  // return filter and filtered products length to be used in Configure component
  // for hitsPerPage and filters
  return { filter, filteredProductLength: filteredProducts.length };
};

const getProductSlug = (product) => {
  // for Algolia products
  if (product.slug) return product.slug;

  // for CMS products that contain static SLI data
  if (product.product_slug) return product.product_slug;

  // for CMS products that contain SLI data
  // but are missing "product_slug" property
  if (product.url) return product.url.split('/')[product.url.split('/').length - 1];

  return '/';
};

export { createProductSlugFilter, getProductSlug };
